var map = {
	"./layout-default/portal/pages/Webshop/WebshopRedirect": [
		"b94a",
		"chunk-7be23e57",
		"chunk-1b4e7f6d",
		"chunk-3a7b9974",
		"chunk-7cc16d36",
		"chunk-54431b7a"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1948";
module.exports = webpackAsyncContext;